import * as React from 'react'
import { cn } from '@/utilities/cn'
import { Container } from '@/components/Container'

export interface SidebarLayoutProps {
  main: React.ReactNode
  /** Optional sidebar — when absent the layout falls back to a single column. */
  sidebar?: React.ReactNode
  /** Which side the sidebar is on (defaults to right). */
  side?: 'left' | 'right'
  className?: string
}

export const SidebarLayout: React.FC<SidebarLayoutProps> = ({
  main,
  sidebar,
  side = 'right',
  className,
}) => {
  if (!sidebar) {
    return (
      <Container className={cn('py-12 lg:py-16', className)}>
        <div>{main}</div>
      </Container>
    )
  }

  return (
    <Container className={cn('py-12 lg:py-16', className)}>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {side === 'left' ? <aside className="space-y-6">{sidebar}</aside> : null}
        <div className="lg:col-span-2">{main}</div>
        {side === 'right' ? <aside className="space-y-6">{sidebar}</aside> : null}
      </div>
    </Container>
  )
}

export default SidebarLayout
